export const accountParams = <const>['currencyCode', 'sortCode', 'bankAccountNumber'];
